import * as React from 'react';
import Popup, { IPopup } from './newPopup';
import styled from 'styled-components';

const WrapperMessagePopup = styled.div(
  ({ theme }) => `
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding : 0 10px 0 10px;
      align-items: center;
`
);

const MessageTextPopup = styled.div(
  ({ theme }) => `
      font-size : 14px;
      font-weight: bold;
      color: ${theme.colors.black};
      padding : 10px 0 10px 0;
      min-width: 100px;
      text-align: center;
`
);

interface IDeleteAllDataPopupProps extends IPopup {
  italic: string;
}

export const DeleteAllDataPopup: React.FC<IDeleteAllDataPopupProps> = (props: IDeleteAllDataPopupProps) => {
  const { grayButtonAction, blueButtonText, blueButtonAction, grayButtonText, boldText, dataAt, italic } = props;

  return (
    <Popup
      grayButtonAction={grayButtonAction}
      blueButtonAction={blueButtonAction}
      grayButtonText={grayButtonText}
      blueButtonText={blueButtonText}
      boldText={boldText}
      dataAt={dataAt}
    >
      <WrapperMessagePopup>
        <MessageTextPopup style={{ fontStyle: 'italic' }}>{italic}</MessageTextPopup>
      </WrapperMessagePopup>
    </Popup>
  );
};
